import { useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Link, useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { IconEyeOff, IconEye } from '@tabler/icons-react';

import InputText from 'components/InputText';
import InputTextArea from 'components/InputTextArea';
import DateOfBirthInput from 'components/DateOfBirthInput';
import { API_URL, post } from 'lib/network/api';

export default function Register() {
  const navigate = useNavigate();
  const [ShowPassword, setShowPassword] = useState(false);

  // ✅ Yup validation schema
  const RegisterSchema = Yup.object().shape({
    first_name: Yup.string().required('First name is required').max(50, 'First name is too long'),
    last_name: Yup.string().required('Last name is required').max(50, 'Last name is too long'),
    password: Yup.string()
      .required('Password is required')
      .min(6, 'Password must be at least 6 characters'),
    email: Yup.string().email('Invalid email format').required('Email is required'),
    phone_number: Yup.string()
      .required('Phone number is required')
      .matches(/^[0-9]+$/, 'Phone number must contain only numbers')
      .min(9, 'Phone number too short')
      .max(15, 'Phone number too long'),
    address: Yup.string().required('Address is required').max(300, 'Address is too long'),
    child_name: Yup.string().required('Child name is required').max(100, 'Child name is too long'),
    child_date_of_birth: Yup.string()
      .required('Child DOB is required')
      .matches(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format (YYYY-MM-DD)'),
  });

  // ✅ Setup useMutation untuk register
  const registerMutation = useMutation({
    mutationFn: async (payload) => post(`${API_URL}/api/register`, payload),
    onSuccess: () => {
      toast.success('Account created successfully!');
      navigate('/login');
    },
    onError: (error) => {
      toast.error(error?.detail || 'Registration failed');
    },
  });

  const handleOnSubmit = (values) => {
    const payload = {
      name: `${values.first_name} ${values.last_name}`,
      email: values.email,
      phone_number: values.phone_number,
      password: values.password,
      address: values.address,
      child_name: values.child_name,
      child_date_of_birth: values.child_date_of_birth,
    };

    registerMutation.mutate(payload);
  };

  return (
    <div className="flex flex-row h-screen flex-1">
      {/* Form Section */}
      <div className="flex flex-1 px-4 py-4">
        <div className="relative w-full">
          <a href="/">
            <img
              alt="KiN Space"
              src="kin/assest/logo.png"
              className="h-10 w-auto absolute left-0"
            />
          </a>

          <div className="flex flex-col h-full justify-center">
            <div className="mx-auto w-full max-w-md lg:w-[448px]">
              <div className="text-center mb-6">
                <h2 className="mt-8 text-xl font-bold text-kin-text">Create your account</h2>
                <span className="mt-2 block text-sm font-light">
                  Welcome to KiN Space! Let’s set up your account!
                </span>

                {/* <div className="my-6 grid grid-cols-1 gap-4">
                <a
                  href="/register"
                  className="flex w-full items-center justify-center gap-3 rounded-[20px] bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:ring-transparent">
                  <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5">
                    <path
                      d="M12.0003 4.75C13.7703 4.75 15.3553 5.36002 16.6053 6.54998L20.0303 3.125C17.9502 1.19 15.2353 0 12.0003 0C7.31028 0 3.25527 2.69 1.28027 6.60998L5.27028 9.70498C6.21525 6.86002 8.87028 4.75 12.0003 4.75Z"
                      fill="#EA4335"
                    />
                    <path
                      d="M23.49 12.275C23.49 11.49 23.415 10.73 23.3 10H12V14.51H18.47C18.18 15.99 17.34 17.25 16.08 18.1L19.945 21.1C22.2 19.01 23.49 15.92 23.49 12.275Z"
                      fill="#4285F4"
                    />
                    <path
                      d="M5.26498 14.2949C5.02498 13.5699 4.88501 12.7999 4.88501 11.9999C4.88501 11.1999 5.01998 10.4299 5.26498 9.7049L1.275 6.60986C0.46 8.22986 0 10.0599 0 11.9999C0 13.9399 0.46 15.7699 1.28 17.3899L5.26498 14.2949Z"
                      fill="#FBBC05"
                    />
                    <path
                      d="M12.0004 24.0001C15.2404 24.0001 17.9654 22.935 19.9454 21.095L16.0804 18.095C15.0054 18.82 13.6204 19.245 12.0004 19.245C8.8704 19.245 6.21537 17.135 5.2654 14.29L1.27539 17.385C3.25539 21.31 7.3104 24.0001 12.0004 24.0001Z"
                      fill="#34A853"
                    />
                  </svg>
                  <span className="text-sm font-semibold leading-6">Sign up with Google</span>
                </a>
              </div> */}

                {/* <div className="relative font-bold text-kin-text">
                  <div aria-hidden="true" className="absolute inset-0 flex items-center">
                    <div className="w-full border-t-[0.5px] border-kin-text" />
                  </div>
                  <div className="relative flex justify-center">
                    <span className="bg-kin-textsecondary px-3 text-sm">Or</span>
                  </div>
                </div> */}
              </div>

              <Formik
                initialValues={{
                  first_name: '',
                  last_name: '',
                  phone_number: '',
                  email: '',
                  password: '',
                  address: '',
                  child_name: '',
                  child_date_of_birth: '',
                }}
                validationSchema={RegisterSchema}
                onSubmit={handleOnSubmit}>
                {({ handleSubmit }) => (
                  <form onSubmit={handleSubmit} className="space-y-3 lg:space-y-3">
                    <div className="flex gap-4">
                      <div className="flex-1">
                        <InputText name="first_name" type="text" label="FIRST NAME" required />
                      </div>
                      <div className="flex-1">
                        <InputText name="last_name" type="text" label="LAST NAME" required />
                      </div>
                    </div>

                    <InputText
                      name="password"
                      label="PASSWORD"
                      type={ShowPassword ? 'text' : 'password'}
                      icon={
                        ShowPassword ? (
                          <IconEyeOff className="text-primary-main h-5 w-5" />
                        ) : (
                          <IconEye className="text-gray-400 h-5 w-5" />
                        )
                      }
                      clickicon={() => setShowPassword(!ShowPassword)}
                      required
                    />

                    <InputText name="email" type="email" label="EMAIL" required />
                    <InputText name="phone_number" type="text" label="PHONE NUMBER" required />
                    <InputTextArea
                      name="address"
                      label="ADDRESS"
                      placeholder="Enter your full address"
                      rows={4}
                      required
                    />

                    {/* ✅ CHILDREN INFO */}
                    <div>
                      <h4 className="text-base text-kin-text font-semibold mb-1">
                        Children Information
                      </h4>
                      <div className="flex gap-4">
                        <div className="flex-1">
                          <InputText name="child_name" type="text" label="CHILD NAME" required />
                        </div>
                        <DateOfBirthInput name="child_date_of_birth" />
                      </div>
                    </div>

                    <button
                      type="submit"
                      disabled={registerMutation.isPending}
                      className="w-full bg-primary-main text-white rounded-[100px] py-3 px-3 flex justify-center items-center disabled:opacity-60">
                      {registerMutation.isPending ? (
                        <span className="text-xs font-semibold">PROCESSING...</span>
                      ) : (
                        <span className="text-xs font-semibold">SIGN UP</span>
                      )}
                    </button>

                    <p className="mt-6 text-center text-sm text-gray-500 font-light">
                      Already have an account?{' '}
                      <Link
                        to="/login"
                        className="text-kin-text font-semibold hover:text-primary-dark">
                        Log In
                      </Link>
                    </p>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      {/* Image Section */}
      <div className="hidden lg:flex flex-1 justify-center items-center py-10">
        <div className="w-[80%] relative h-full">
          <img
            alt="register"
            src="kin/assest/image/register.png"
            className="absolute inset-0 h-full w-full object-cover rounded-lg"
          />
        </div>
      </div>
    </div>
  );
}
